<template>
  <!-- 会员页面 -->
  <div class="vip">
    <Top></Top>
    <div class="banner">
      <img src="../imgs/banner.png" style="width: 100%; height: auto" />
    </div>
    <div class="vip-content acea-row">
      <div class="vip-content-item" v-for="(item, index) in vipValue1" :key="index">
        <div class="vip-name">{{ item.menuName }}</div>
        <div class="vip-desc">
          <div>下载图片/视频数{{ item.availableNumber }}个</div>
          <div>有效期 {{ item.effectiveDay }}天</div>
          <div>（限AI二创及训练、新媒体宣发应用）</div>
        </div>
        <div class="line"></div>
        <div class="vip-price">{{ item.menuPrice }}<span style="font-size: 16px;">元</span></div>
        <a class="buy-vip-btn" @click="clickBTN1(item.menuNumber)">购买套餐</a>
        <div class="vip-tip">*所有作品均不可搬运用于同类网站</div>
      </div>
      <!-- <div class="vip-content-item">
        <div class="vip-name">{{vipValue1[1].menuName}}</div>
        <div class="vip-desc">
          <div>下载图片/视频数{{vipValue1[1].availableNumber}}个</div>
          <div>有效期 {{vipValue1[1].effectiveDay}}天</div>
          <div>图片/视频单价约{{vipValue1[1].unitPrice}}元</div>
        </div>
        <div class="line"></div>
        <div class="vip-price">{{vipValue1[1].menuPrice}}<span style="font-size: 16px;">元</span></div>
        <a
          @click="clickBTN2"
          class="buy-vip-btn"
        >购买套餐</a>
      </div>
      <div class="vip-content-item">
        <div class="vip-name">{{vipValue1[2].menuName}}</div>
        <div class="vip-desc">
          <div>下载图片/视频数 {{vipValue1[2].availableNumber}}个</div>
          <div>有效期 {{vipValue1[2].effectiveDay}}天</div>
          <div>图片/视频单价约{{vipValue1[2].unitPrice}}元</div>
        </div>
        <div class="line"></div>
        <div class="vip-price">{{vipValue1[2].menuPrice}}<span style="font-size: 16px;">元</span></div>
        <a
          @click="clickBTN3"
          class="buy-vip-btn"
        >购买套餐</a>
      </div> -->
    </div>
    <div class="block-title">购买使用流程</div>
    <div class="main-row acea-row row-between-wrapper">
      <div class="progress-item acea-row row-middle">
        <div class="progress-num">1</div>
        <div>
          <div class="progress-title">购买套餐</div>
          <div class="progress-desc">
            <div>· 根据需要的图片/视频个数选择套餐</div>
            <div>· 完成付款后可在线申请发票</div>
          </div>
        </div>
      </div>
      <div class="progress-item acea-row row-middle">
        <div class="progress-num">2</div>
        <div>
          <div class="progress-title">下载图片/视频</div>
          <div class="progress-desc">
            <div>· 购买套餐后，通过搜索等方式挑选图片</div>
            <div>· 图片/视频详情页下载</div>
          </div>
        </div>
      </div>
      <div class="progress-item acea-row row-middle">
        <div class="progress-num">3</div>
        <div>
          <div class="progress-title">下载授权书</div>
          <div class="progress-desc">
            <div>· 根据需要的图片/视频个数选择套餐</div>
            <div>· 设置完成即可在线下载电子授权书</div>
          </div>
        </div>
      </div>
    </div>
    <div class="block-title">授权用途范围对比</div>
    <div class="main-row acea-row" style="padding: 0 15px;margin-bottom: 20px;font-size: 18px;">
      <div class="row-main">用途限制-图片</div>
      <div class="row-right">标准授权</div>
      <div class="row-right">扩展授权</div>
      <div class="row-right">会员授权</div>
    </div>
    <ul class="table main-row" style="padding-left: 0;">
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">适用范围：</div>
          <div class="row-desc">媒体广告</div>
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">数字用途：</div>
          <div class="row-desc">
            <span>自媒体文章配图</span>
            <span class="row-desc-express">（例如新浪微博、网易、头条号、微信公众号等）</span>
          </div>
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title"></div>
          <div class="row-desc">
            <span>自媒体短视频、自媒体直播配图</span>
            <span class="row-desc-express">（例如：快手、头条等）</span>
          </div>
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title"></div>
          <div class="row-desc">
            <span>电商平台商品详情页配图</span>
            <span class="row-desc-express">（例如淘宝、天猫、京东网、拼多多）</span>
          </div>
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title"></div>
          <div class="row-desc">
            <span>网站、客户端商业广告配图</span>
          </div>
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">线下印刷</div>
          <div class="row-desc">
            <span>宣传页，手册、海报，易拉宝等线下印刷</span>
          </div>
        </div>
        <div class="row-right">
          限量100万份
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title"></div>
          <div class="row-desc">
            <span>报纸、杂志及图书等内文印刷</span>
          </div>
        </div>
        <div class="row-right">
          限量100万份
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title"></div>
          <div class="row-desc">
            <span>报纸、杂志及图书封面及封底印刷</span>
          </div>
        </div>
        <div class="row-right">
          限量100万份
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">户外广告：</div>
          <div class="row-desc">
            <span>楼宇、车身、灯箱、围挡、橱窗等户外广告及户外视频广告、公共表演、展会展览等</span>
          </div>
        </div>
        <div class="row-right">
          不支持
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">转售商品：</div>
          <div class="row-desc">
            <span>在数字商品中使用，包括软件程序，设计模板，壁纸，主题皮肤课件等</span>
          </div>
        </div>
        <div class="row-right">
          不支持
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title"></div>
          <div class="row-desc">
            <span>在实物商品中使用，包括手机壳、贺卡、明信片、日历、杯子、T恤、包装、实物礼品等</span>
          </div>
        </div>
        <div class="row-right">
          不支持
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">影视制作：</div>
          <div class="row-desc">
            <span>网络电视，网络视频，电影，电视节目等</span>
          </div>
        </div>
        <div class="row-right">
          不支持
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">敏感用途：</div>
          <div class="row-desc">
            <span>医疗、药物、烟草、美容整容、保健品类广告及宣传</span>
          </div>
        </div>
        <div class="row-right">
          不支持
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">商标Logo:</div>
          <div class="row-desc">
            <span>商标、LOGO</span>
          </div>
        </div>
        <div class="row-right">
          不支持
        </div>
        <div class="row-right">
          不支持
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">授权期限：</div>
          <div class="row-desc">
            <span></span>
          </div>
        </div>
        <div class="row-right">
          下载后可永久使用
        </div>
        <div class="row-right">
          下载后可永久使用
        </div>
        <div class="row-right">
          会员期内可使用
        </div>
      </li>
    </ul>
    <div class="main-row acea-row" style="padding: 20px 15px;font-size: 18px;">
      <div class="row-main">用途限制-视频</div>
    </div>
    <ul class="table main-row" style="padding-left: 0;margin-bottom: 120px;">
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">媒体出版：</div>
          <div class="row-desc">出版媒体、编辑网站、博客、微博、微信公众号、自媒体号等非商业性使用</div>
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">在线广告：</div>
          <div class="row-desc">网络广告，社交网络、移动设备广告、移动应用程序（APP）、电脑软件（限于非售卖类软件）</div>
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">现场演出：</div>
          <div class="row-desc">现场表演或演出中</div>
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">个人欣赏：</div>
          <div class="row-desc">学习、研究（不得进行转售、分销、提供他人复制、下载使用）</div>
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">电影电视：</div>
          <div class="row-desc">电视、电影、微电影、网络视频、多媒体演示</div>
        </div>
        <div class="row-right">
          不支持
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">户外广告：</div>
          <div class="row-desc">户外广告、地铁广告</div>
        </div>
        <div class="row-right">
          不支持
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
        <div class="row-right">
          <img class="gou" src="../imgs/gou.svg">
        </div>
      </li>
      <li class="acea-row table-row">
        <div class="row-main">
          <div class="row-title">授权期限：</div>
        </div>
        <div class="row-right">
          下载后可永久使用
        </div>
        <div class="row-right">
          下载后可永久使用
        </div>
        <div class="row-right">
          会员期内可使用
        </div>
      </li>
    </ul>
    <!-- 联系客服 -->
    <service />
    <!-- 回到顶部 -->
    <el-backtop :visibility-height="300" :bottom="200">
      <div class="inn">
        <img src="@/imgs/backtop.png" alt="">
      </div>
    </el-backtop>

    <Foot></Foot>
  </div>
</template>
<script>
import service from '@/components/service.vue'
import Top from "../components/top.vue";
import Foot from "../components/foot.vue";
export default {
  name: "vip",
  components: { Top, Foot, service },
  data() {
    return {
      vipValue1: [],
      payActive: null
    };
  },
  created() {
    this.vipValue()
  },
  methods: {
    async vipValue() {
      const res = await this.$axios.get('/homeReception/memberPrice')
      console.log(res);
      this.vipValue1 = res.data
      // console.log(this.vipValue1);
    },
    // 点击套餐跳转和路由参数
    clickBTN1(menuNumber) {
      let token = window.localStorage.getItem('token')
      if (!token) {
        this.$message.info('请先登录')
        // 存回跳地址
        window.sessionStorage.setItem('backUrl', this.$route.fullPath)
        this.$router.push('/login')
      } else {
        // console.log(this.payActive);
        this.$router.push({
          path: "/vipbuy",
          query: {
            menuNumber: menuNumber,
          },
        });
      }

    },
    // clickBTN2() {
    //   this.payActive = 2
    //   this.$router.push({
    //     path: "/vipbuy",
    //     query: {
    //       menuNumber: this.vipValue1[1].menuNumber,
    //       payActive: this.payActive,
    //       price: this.vipValue1[1].menuPrice
    //     },
    //   });
    // },
    // clickBTN3() {
    //   this.payActive = 3
    //   console.log(this.vipValue1[2].menuNumber);
    //   this.$router.push({
    //     path: "/vipbuy",
    //     query: {
    //       menuNumber: this.vipValue1[2].menuNumber,
    //       payActive: this.payActive,
    //       price: this.vipValue1[2].menuPrice
    //     },
    //   });
    // }
  }
};
</script>
<style lang="scss" scoped>
body,
html {
  background-color: #ffffff;
}

.banner {
  min-width: 1200px;
  position: relative;
}

.vip-content {
  width: 1200px;
  min-height: 530px;
  border-radius: 10px;
  background-color: #ffffff;
  margin: 0 auto;
  margin-top: -150px;
  position: relative;
  z-index: 2;
  box-shadow: 2px 2px 6px rgba(1, 1, 1, 0.1);
}

.vip-content-item {
  flex: 1;
  margin: 50px 50px 0 50px;
  position: relative;
  text-align: center;
  color: #333333;
}

.vip-content-item:nth-of-type(2)::before {
  content: "";
  display: block;
  height: 400px;
  border-right: 1px solid #eeeeee;
  position: absolute;
  left: -50px;
  top: 0;
}

.vip-content-item:nth-of-type(2)::after {
  content: "";
  display: block;
  height: 400px;
  border-right: 1px solid #eeeeee;
  position: absolute;
  right: -50px;
  top: 0;
}

.vip-content-item:nth-of-type(3)::after {
  content: "";
  display: block;
  height: 400px;
  border-right: 1px solid #eeeeee;
  position: absolute;
  right: -50px;
  top: 0;
}

.vip-name {
  font-size: 24px;
  margin-bottom: 54px;
}

.vip-desc {
  color: #777777;
}

.vip-desc>div {
  margin-bottom: 15px;
}

.line {
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  margin-top: 40px;
  margin-bottom: 30px;
}

.vip-price {
  font-size: 40px;
  margin-bottom: 20px;
}

.buy-vip-btn {
  width: 100%;
  height: 60px;
  background: #da3a3a;
  color: #ffffff !important;
  line-height: 60px;
  font-size: 22px;
  border-radius: 60px;
  cursor: pointer;
  display: block;
}

.vip-tip {
  font-size: 14px;
  color: #999999;
  margin-top: 15px;
}

.progress-num {
  font-size: 80px;
  /* font-weight: bold; */
  color: #da3a3a;
  margin-right: 15px;
}

.progress-title {
  font-size: 20px;
}

.progress-desc {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.block-title {
  text-align: center;
  font-size: 30px;
  margin-top: 100px;
  margin-bottom: 40px;
}

.gou {
  width: 25px;
  height: 25px;
  object-fit: contain;
}

.table-row {
  height: 40px;
  padding: 0 15px;
  font-size: 14px;
}

.table-row:nth-of-type(odd) {
  background-color: #f5f5f5;
}

.table-row .row-title {
  color: #999;
  width: 70px;
}

.row-main {
  flex: 6;
  display: flex;
  align-items: center;
}

.row-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.row-desc-express {
  color: #777;
}

.main-row {
  width: 1200px;
  margin: 0 auto;
}

.acea-row {
  display: flex;
  flex-wrap: wrap;
}

.acea-row.row-middle {
  align-items: center;
}

.acea-row.row-between-wrapper {
  align-items: center;
  /* justify-content: flex-start; */
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/vip/vip.vue